<template>
    <ht class="rkm-divider" />
</template>

<script>
export default {

}
</script>

<style scoped>
.rkm-divider {
    border: 1px solid rgba(0, 0, 0, 0.12);
    display: block;
    flex: 1 1 0px;
    height: 0;
    margin-bottom: 5px;
    margin-top: 5px;
    max-height: 0;
    max-width: 100%;
}
</style>